<template>
  <div class="fullscrean">
    <div>
      <img src="../assets/logo-lecard.png" alt="Logo Lecard" style="width: 120px">
      <div class="mt-4">
        <h5 class="mb-3 font-weight-bold">Atualize seu plano</h5>
        <p class="mb-4" style="max-width: 500px">
          Gestão de mesas, comandas, delivery por telefone, fechamento de caixa,
          relatórios administrativos, emissão de cupom fiscal (NFC-e), e o melhor, seus pedidos e vendas integrados em um só lugar.
        </p>
        <div>
          <a href="https://wa.me/5516994533763?text=Iniciar%20atendimento" target="_blank" class="btn btn-primary">Quero contratar!</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "@/components/commons/TopBar";
  export default {
    name: 'Upgrade',
    components: {TopBar},
  }
</script>

<style scoped>
.fullscrean {
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  width: 100%;
  text-align: center;
}

@media (max-height: 630px) {
  .fullscrean {
    height: auto;
    margin-top: 132px;
  }
}
</style>
